import { ASSETS_DEFINITION } from './assetsDefinition'

import { ASSETS_TYPES } from './assetsTypes'

import { config } from 'config'
const { NODE_ENV } = config

export { ASSETS_TYPES }

export const STOCK_MARKET_TIME = {
  openTimeUtc: '13:30',
  closeTimeUtc: '19:55',
}

export const STOCK_MARKET_DAYS_OFF = [
  {
    dateObj: { month: 2, day: 20 },
    reason: {
      title: `Due to Presidents' Day, stocks are currently closed for trading.`,
      subtitle: `The markets will be open this week from Tuesday - Friday from ${STOCK_MARKET_TIME.openTimeUtc} UTC to  ${STOCK_MARKET_TIME.closeTimeUtc} UTC.`,
    },
  },
  {
    dateObj: { month: 3, day: 29 },
    reason: {
      title: `The stocks are currently closed for trading today.`,
      subtitle: ` The markets will be open next week from Monday - Friday from ${STOCK_MARKET_TIME.openTimeUtc} UTC to  ${STOCK_MARKET_TIME.closeTimeUtc} UTC.`,
    },
  },
  {
    dateObj: { month: 4, day: 7 },
    reason: {
      title: `The stocks are currently closed for trading today.`,
      subtitle: ` The markets will be open next week from Monday - Friday from ${STOCK_MARKET_TIME.openTimeUtc} UTC to  ${STOCK_MARKET_TIME.closeTimeUtc} UTC.`,
    },
  },
  {
    dateObj: { month: 5, day: 29 },
    reason: {
      title: `Due to the holiday, stocks are currently closed for trading. `,
      subtitle: `The markets will be open this week from Tuesday - Friday from ${STOCK_MARKET_TIME.openTimeUtc} UTC to  ${STOCK_MARKET_TIME.closeTimeUtc} UTC.`,
    },
  },
  {
    dateObj: { month: 6, day: 19 },
    reason: {
      title: `Stock markets are closed today`,
      subtitle: `The markets will be open this week from Tuesday - Friday from ${STOCK_MARKET_TIME.openTimeUtc} UTC to  ${STOCK_MARKET_TIME.closeTimeUtc} UTC.`,
    },
  },
]

export const ASSETS = Object.keys(ASSETS_DEFINITION)
  .map((assetId) => ({ ...ASSETS_DEFINITION[assetId] }))
  .filter((assetDef) => (NODE_ENV === 'production' ? assetDef.prodReady : true))

export const getAssetInfo = (assetId) => {
  const assetInfo = ASSETS.filter((asset) => {
    return asset.id === assetId
  }).at(0)
  return assetInfo || {}
}

// export const ASSETS = [...MEME_COIN, ...YOLO_ETF, ...CRYPTO].map((asset) => ({
//   ...ASSETS_DEFINITION[asset.id],
//   ...asset,
// }))

// uncomment below to see the assets
// const kk = ASSETS.reduce((obj, asset) => {
//   return { ...obj, [asset.id]: asset.games }
// }, {})
// console.log('ACZ ASSETS -->', ASSETS)
